import { render, staticRenderFns } from "./endereco.vue?vue&type=template&id=efa15bfa&"
import script from "./endereco.vue?vue&type=script&lang=js&"
export * from "./endereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports